import request, { baseURL, METHODS } from '@/api'
import {Button, InputNumber, Switch, Space, Table, Select, message} from 'antd'
import { useEffect, useRef, useState } from 'react'
import {SDrawerOrModal, SSkuCard, SFormUploadImage, SGeneralForms, SLowcodeList} from 'shj-components'
import { getProductList } from '@/services/product'

interface Iprops {
  open: boolean
  onCancel: () => void
  title: string
  record?: any
  data: Array<any>
  idList: Array<any>
  save: () => void
}

export default function ChooseDetailModal(props: Iprops) {
  const { open, onCancel = () => ({}), title, save = (data) => ({}), record, data = [], idList = [] } = props;
  const [btnLoading, setBtnLoading] = useState<boolean>(false);
  const [productList, setProductList] = useState<Array<any>>([]);
  const [tableData, setTableData] = useState<Array<any>>([]);
  const [selelctIdList, setSelelctIdList] = useState<Array<any>>([]);
  const [skuModalOpen, setSkuModalOpen] = useState<boolean>(false);
  const [originSkuList, setOriginSkuList] = useState<Array<any>>([]);
  const [chooseProductId, setChooseProductId] = useState('');
  const listRef = useRef()

  useEffect(() => {
    if (data?.length) {
      setTableData(data);
    }

    if (idList?.length) {
      setSelelctIdList(idList);
    }
    fetchProductList();
  }, [])
  
  const fetchProductList = async () => {
    try {
      const res: any = await getProductList({
        prodTypes: ['PRODUCT_SINGLE', 'PRODUCT_BASIC_ITEM'],
        querySkus: true,
      })
      if (res) {
        const formatRes = res.map(item => ({ ...item, label: item.prodName, value: item.id, productId: item.id }))
        setProductList(formatRes);
      }
    } catch (err) {
      console.log(err);
    }
  }

  const columns = [
    {
      title: '物料',
      dataIndex: 'product',
      key: 'product',
      width: 300,
      align: 'left',
      render: (value, record) => (
        <div>
          <SSkuCard
            url={record?.mainPicUrl}
            title={
              <div style={{ height: '100%' }}>
                <p>{record?.prodName}</p>
              </div>
            }
            desc={<p>{record?.id}</p>}
            operation={() => {
              return <div> </div>
            }}
          ></SSkuCard>
        </div>
      ),
    },
    {
      title: '单位',
      dataIndex: 'unitInfo',
      key: 'unitInfo',
      align: 'center',
      width: 80,
      render: (value) => (
        <span>{ value?.unitName }</span>
      )
    },
    {
      title: '数量',
      dataIndex: 'size',
      key: 'size',
      align: 'center',
      width: 100,
      render: (value, record) => (
        <InputNumber
          min={0}
          precision={4}
          style={{ width: '100%' }}
          value={value}
          onChange={(value) => {
            const list = tableData.map((product: any) => {
              if (product.id === record?.id) {
                return {
                  ...product,
                  size: value
                }
              }
              return {
                ...product,
              }
            });
            setTableData(list);
          }}
        />
      )
    },
    {
      title: '是否可查看',
      key: 'allowView',
      dataIndex: 'allowView',
      align: 'center',
      width: 120,
      render: (value, record) => (
        <>
          <Switch
            checkedChildren="是"
            unCheckedChildren="否"
            checked={value}
            onClick={checked => {
              const list = tableData.map((product: any) => {
                if (product.id === record?.id) {
                  return {
                    ...product,
                    allowView: checked
                  }
                }
                return {
                  ...product,
                }
              });
              setTableData(list);
            }}
          />
        </>
      ),
    },
    {
      title: '是否必选',
      key: 'required',
      dataIndex: 'required',
      align: 'center',
      width: 100,
      render: (value, record) => (
        <>
          <Switch
            checkedChildren="是"
            unCheckedChildren="否"
            checked={value}
            onClick={checked => {
              const list = tableData.map((product: any) => {
                if (product.id === record?.id) {
                  return {
                    ...product,
                    required: checked
                  }
                }
                return {
                  ...product,
                }
              });
              setTableData(list);
            }}
          />
        </>
      ),
    },
    {
      title: '是否参与计算',
      key: 'allowCalculation',
      dataIndex: 'allowCalculation',
      align: 'center',
      width: 120,
      render: (value, record) => (
        <>
          <Switch
            checkedChildren="是"
            unCheckedChildren="否"
            checked={value}
            onClick={checked => {
              const list = tableData.map((product: any) => {
                if (product.id === record?.id) {
                  return {
                    ...product,
                    allowCalculation: checked
                  }
                }
                return {
                  ...product,
                }
              });
              setTableData(list);
            }}
          />
        </>
      ),
    },
    {
      title: '是否发包',
      key: 'allowSendPack',
      dataIndex: 'allowSendPack',
      align: 'center',
      width: 100,
      render: (value, record) => (
        <>
          <Switch
            checkedChildren="是"
            unCheckedChildren="否"
            checked={value}
            onClick={checked => {
              const list = tableData.map((product: any) => {
                if (product.id === record?.id) {
                  return {
                    ...product,
                    allowSendPack: checked
                  }
                }
                return {
                  ...product,
                }
              });
              setTableData(list);
            }}
          />
        </>
      ),
    },
    {
      title: '操作',
      key: 'action',
      align: 'center',
      fixed: 'right',
      width: 160,
      render: (_, record) => (
        <Space size="middle">
          <a onClick={() => handleChooseSku(record)}>选择sku</a>
          <a onClick={() => handleRemove(record)}>移除</a>
        </Space>
      ),
    },
  ];

  const handleRemove = (record) => {
    const newDataList = tableData?.filter(item => item.id !== record.id);
    const idList = newDataList.map(item => item.id)
    setTableData(newDataList);
    setSelelctIdList(idList);
  }

  const handleChooseSku = (record) => {
    setChooseProductId(record.id);
    setOriginSkuList(record.skuList || []);
    listRef.current?.updateDataSource([...(record.skuList || [])], record.skuList?.length)
    if (record.skuIds) {
      setTimeout(() => {
        listRef.current?.setSelectedRowKeys([...record.skuIds]);
      }, 200)
    }
    setSkuModalOpen(true);
  }

  const handleChooseProduct = (idList: any) => {
    setSelelctIdList(idList);
    const product = productList.filter((item: any) => idList.includes(item.value));
    // 把table数据同步
    if (tableData?.length) {
      const newList: any = [];
      product.forEach(item => {
        const index = tableData.findIndex(data => data.id === item.id);
        if (index !== -1) {
          // 有了就不动
          newList.push(tableData[index]);
        } else {
          // 新的给默认值
          newList.push({ ...item, size: 1, allowView: true, required: true, allowCalculation: true, allowSendPack: true, skuIds: item.skuList?.map(sku => sku.id)});
        }
      });
      setTableData([
        ...newList
      ]);
      return;
    }
    const firstList = product?.map(item => ({ ...item, size: 1, allowView: true, required: true, allowCalculation: true, allowSendPack: true, skuIds: item.skuList?.map(sku => sku.id) }))
    setTableData([
      ...firstList
    ]);
  }

  const onsubmit = () => {
    save(tableData);
    onCancel();
  }

  const config = {
    rowSelection: {
      preserveSelectedRowKeys: true
    },
    columns: [
      {
        title: 'SKU编码',
        dataIndex: 'id',
        width: 200,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: 'SKU名称',
        dataIndex: 'skuName',
        width: 300,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: '规格',
        dataIndex: 'argName',
        width: 200,
      },
      {
        title: '单位',
        dataIndex: ['unitInfo', 'unitName'],
        width: 100,
      },
      {
        title: '单价',
        dataIndex: ['skuPrice', 'buyPrice'],
        width: 100,
      },
    ],
    search: [
      {
        name: 'id',
        label: 'SKU编码',
      },
      {
        name: 'skuName',
        label: 'SKU名称',
      },
    ],
    footer: [],
    batchActions: [],
    scroll: {
      y: 200,
    }
  }

  const fetchList = async (values) => {
    if (values?.query && Object.keys(values.query).length) {
      const newList = originSkuList.filter(sku => {
        const valuesList = Object.keys(values.query).filter(item => values?.query?.[item]).filter(item => !sku?.[item]?.includes(values.query?.[item]))

        if (valuesList.length) {
          return false;
        } else {
          return true;
        }
      })

      return {records: [...newList], total: newList.length}
    } else {
      return {records: [...originSkuList], total: originSkuList.length}
    }
  }

  const handleSaveSku = () => {
    const skuIds = listRef?.current?.getSelectedRows()?.[0];
    if (!skuIds?.length) {
      message.error('必须选择一个sku');
      return;
    }
    const newDataList = tableData?.map(item => {
      if (item.id === chooseProductId) {
        return {
          ...item,
          skuIds,
        }
      }
      return {
        ...item,
      }
    });
    setTableData(newDataList);
    setSkuModalOpen(false);
  }

  const extensions = {
    request: {fetchList},
  }
  return (
    <>
      <SDrawerOrModal
        mode="drawer"
        title={title}
        open={open}
        onCancel={onCancel}
        destroyOnClose
        width={1010}
        antdProps={{
          footer: <div style={{ textAlign: 'right' }}>
            <Button loading={btnLoading} style={{ marginRight: '10px' }} onClick={onCancel}>
              取消
            </Button>
            <Button loading={btnLoading} type="primary" onClick={onsubmit}>
              保存
            </Button>
          </div>
        }}
      >
        <div style={{ marginBottom: '20px' }}>
          <div style={{ marginBottom: '8px', fontWeight: 600 }}>选择产品</div>
          <Select
            showSearch
            optionFilterProp="label"
            mode="multiple"
            style={{
              width: '460px',
            }}
            placeholder="请选择产品"
            defaultValue={[]}
            options={productList}
            onChange={handleChooseProduct}
            value={selelctIdList}
          />
        </div>
        <div>
          <Table
            size={'middle'}
            scroll={{ x: 1000 }}
            columns={columns}
            dataSource={tableData}
            pagination={{
              defaultPageSize: 5
            }}
          />
        </div>
      </SDrawerOrModal>
      {skuModalOpen ? <SDrawerOrModal
        mode="modal"
        title={'选择sku'}
        open={skuModalOpen}
        onCancel={() => setSkuModalOpen(false)}
        destroyOnClose
        width={1010}
        height={'70'}
        antdProps={{
          footer: <div style={{ textAlign: 'right' }}>
            <Button loading={btnLoading} style={{ marginRight: '10px' }} onClick={() => setSkuModalOpen(false)}>
              取消
            </Button>
            <Button loading={btnLoading} type="primary" onClick={handleSaveSku}>
              保存
            </Button>
          </div>
        }}
      >
        <div>
          <SLowcodeList ref={listRef} searchMode="group" config={config} {...extensions} />
        </div>
      </SDrawerOrModal> : null}
    </>
  )
}
